import { render } from "./chat-content.vue?vue&type=template&id=3e44590f"
import script from "./chat-content.vue?vue&type=script&lang=js"
export * from "./chat-content.vue?vue&type=script&lang=js"

import "./chat-content.vue?vue&type=style&index=0&id=3e44590f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__